export class ColumnModel {

   caption: string;
   dataField: string;
   visible: boolean;
   alignment: string;
   visibleIndex: number;
   dataType: string;
   format: string;
   falseText: string;
   trueText: string;
   showEditorAlways: boolean;
   width: number;
   allowEditing: boolean = true;
   allowSorting: boolean = true;
   allowFiltering: boolean = true;
   template: string;
   fixed: boolean = false;
   fixedPosition: string;


   // tslint:disable-next-line:max-line-length
   constructor(values: Object = {}, caption?, dataField?, visible?, alignment?, width?, visibleIndex?, dataType?, format?, falseText?, trueText?, showEditorAlways?, template?) {

      this.caption = caption;
      this.dataField = dataField;
      this.visible = visible;
      this.alignment = alignment;
      this.visibleIndex = visibleIndex;
      this.dataType = dataType;
      this.format = format;
      this.width = width;

      this.falseText = falseText;
      this.trueText = trueText;
      this.showEditorAlways = showEditorAlways;
      this.template = template;

      if (values) {
         Object.assign(this, values);
      }
   }

   static textColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'left',
         visibleIndex: visibleIndex || undefined,
         dataType: 'string',
         encodeHtml: false,
         width: width || undefined
      });
   }

   static booleanColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'left',
         visibleIndex: visibleIndex || undefined,
         dataType: 'boolean',
         falseText: 'NÃ£o',
         trueText: 'Sim',
         showEditorAlways: false,
         width: width || undefined
      });
   }

   static numberColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'right',
         visibleIndex: visibleIndex || undefined,
         dataType: 'number',
         format: { type: 'fixedPoint' },
         width: width || undefined
      });
   }

   static currencyColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'right',
         visibleIndex: visibleIndex || undefined,
         dataType: 'number',
         format: 'currency',
         width: width || undefined
      });
   }

   static dateColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?, format?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'left',
         visibleIndex: visibleIndex || undefined,
         dataType: 'date',
         format: format || 'dd/MM/yyyy',
         width: width || undefined
      });
   }

   static datetimeColumn(dataField, visible, caption?, width?, alignment?, visibleIndex?, format?) {
      return new ColumnModel({
         dataField: dataField,
         visible: visible,
         caption: caption || undefined,
         alignment: alignment || 'left',
         visibleIndex: visibleIndex || undefined,
         dataType: 'datetime',
         format: format || 'dd/MM/yyyy HH:mm:ss',
         width: width || undefined
      });
   }

   static customColumn(template, caption, fixed, fixedPosition, width?) {
      return new ColumnModel({
         dataField: template,
         template: template,
         caption: caption,
         allowEditing: false,
         allowSorting: false,
         allowFiltering: false,
         fixed: fixed,
         fixedPosition: fixedPosition,
         width: width || undefined
      });
   }

}
